import { lazy } from "react";
import { Navigate } from "react-router-dom";
import PendingActionsIcon from '@mui/icons-material/PendingActions';

const ReportSchedulerList = lazy(() => import("../components/reportSchedulerList"));
const ReportSchedulerCreate = lazy(() => import("../components/reportSchedulerCreate"));

const reportSchedulerRoute = [

  {
    icon: PendingActionsIcon,
    name: "Report Scheduler",
    link: "/report-scheduler",
    path: "report-scheduler",
    index: 21,
    element: <ReportSchedulerList />,
    superAdminView: false,
    permission: "Report Scheduler-Read",
  },
  {
    path: "report-scheduler/create",
    element: <ReportSchedulerCreate />,
  },
  {
    path: "report-scheduler/:id",
    element: <ReportSchedulerCreate />,
  },
  {
    path: "",
    element: <Navigate to="/report-scheduler" replace />,
  },
  // ],
];
export default reportSchedulerRoute;
